"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableCells = void 0;
const TableCells_1 = __importDefault(require("./TableCells"));
exports.TableCells = TableCells_1.default;
